/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsrefunded1Inputs */

const en_ticketsrefunded1 = /** @type {(inputs: Ticketsrefunded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order refunded`)
};

const de_ticketsrefunded1 = /** @type {(inputs: Ticketsrefunded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung erstattet`)
};

/**
* | output |
* | --- |
* | "Order refunded" |
*
* @param {Ticketsrefunded1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsrefunded1 = /** @type {((inputs?: Ticketsrefunded1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsrefunded1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsrefunded1(inputs)
	return de_ticketsrefunded1(inputs)
});
export { ticketsrefunded1 as "ticketsRefunded" }